import { Store } from '@ngrx/store';
import { setTargetRatesShowRecessions } from 'TargetRatesApp/apps/target-rates-app/state/show-recessions/show-recessions.actions';
import { UrlsService } from 'Angular/services/core/urls.service';
import { TargetRatesService } from 'TargetRatesApp/services/target-rates.service';
import { SimpleFundChartComponent } from 'ChartApp/ts/features/simple-fund-chart/simple-fund-chart.component';
import { formatChange } from 'Angular/utils/string-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "TargetRatesApp/services/target-rates.service";
import * as i3 from "Angular/services/core/urls.service";
import * as i4 from "../../../../../../charts/static/charts/ts/features/simple-fund-chart/simple-fund-chart.component";
import * as i5 from "@angular/forms";
const _forTrack0 = ($index, $item) => $item.name;
function IntradaysRatesComponent_For_32_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(index_r1.change[0] == "+" ? "text-green" : "text-red");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(index_r1.change);
} }
function IntradaysRatesComponent_For_32_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " -- ");
} }
function IntradaysRatesComponent_For_32_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMap(index_r1.change_percent[0] == "+" ? "text-green" : "text-red");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(index_r1.change_percent);
} }
function IntradaysRatesComponent_For_32_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " -- ");
} }
function IntradaysRatesComponent_For_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td")(2, "a", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 21);
    i0.ɵɵconditionalCreate(7, IntradaysRatesComponent_For_32_Conditional_7_Template, 2, 3, "strong", 22)(8, IntradaysRatesComponent_For_32_Conditional_8_Template, 1, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 21);
    i0.ɵɵconditionalCreate(10, IntradaysRatesComponent_For_32_Conditional_10_Template, 2, 3, "strong", 22)(11, IntradaysRatesComponent_For_32_Conditional_11_Template, 1, 0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r1 = ctx.$implicit;
    const ɵ$index_56_r2 = ctx.$index;
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("bullet-" + (ɵ$index_56_r2 + 1));
    i0.ɵɵproperty("href", index_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", index_r1.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(index_r1.level ? index_r1.level : "--");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(index_r1.change !== null ? 7 : 8);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(index_r1.change_percent !== null ? 10 : 11);
} }
export class IntradaysRatesComponent {
    constructor(store, targetRatesService, urlsService) {
        this.store = store;
        this.targetRatesService = targetRatesService;
        this.urlsService = urlsService;
        this.chartCalcs = ['level'];
        this.indicesList = ['^FVX', '^TNX', '^TYX'];
        this.showRecessions = false;
        this.indices = [];
        this.latestDate = '';
    }
    ngOnInit() {
        this.targetRatesService.getIntraDayRatesIndices().subscribe((response) => {
            this.indices = response.indices_data;
            this.indicesList = response.indices_list;
            this.latestDate = response.latest_date;
            for (let i = 0; i < this.indices.length; i += 1) {
                const levelChange = this.indices[i].change;
                const percentChange = this.indices[i].change_percent;
                if (levelChange) {
                    this.indices[i].change = formatChange(levelChange);
                }
                if (percentChange) {
                    this.indices[i].change_percent = formatChange(percentChange);
                }
            }
        });
    }
    updateShowRecessesions(showRecessions) {
        this.store.dispatch(setTargetRatesShowRecessions({ showRecessions }));
    }
    goToFundChartTab() {
        const queryParams = this.simpleFundChart.getQueryParams();
        window.location.href = `${this.urlsService.CHARTS.FUND_CHART_PAGE}#/?${queryParams}`;
    }
}
IntradaysRatesComponent.ɵfac = function IntradaysRatesComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IntradaysRatesComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.TargetRatesService), i0.ɵɵdirectiveInject(i3.UrlsService)); };
IntradaysRatesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IntradaysRatesComponent, selectors: [["ycn-intradays-rates"]], viewQuery: function IntradaysRatesComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SimpleFundChartComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.simpleFundChart = _t.first);
    } }, standalone: false, decls: 35, vars: 5, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-action"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], ["href", "javascript:void(0)", 1, "btn", "btn-text", 3, "click"], [1, "panel-content"], [1, "row"], [1, "col-lg-7"], [3, "calcs", "showRecessions", "securityIds"], [1, "col-lg-5"], [1, "table"], [1, "text-thin"], [1, "text-right", "text-thin"], [1, "text-right", "text-thin", "text-nowrap"], [1, "panel-date"], [1, "chart-legend-item-title", 3, "href"], [1, "text-right"], [3, "class"]], template: function IntradaysRatesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3, "Intraday Rates");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "label", 5)(7, "input", 6);
        i0.ɵɵtwoWayListener("ngModelChange", function IntradaysRatesComponent_Template_input_ngModelChange_7_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.showRecessions, $event) || (ctx.showRecessions = $event); return $event; });
        i0.ɵɵlistener("ngModelChange", function IntradaysRatesComponent_Template_input_ngModelChange_7_listener($event) { return ctx.updateShowRecessesions($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "span", 7);
        i0.ɵɵelementStart(9, "span", 8);
        i0.ɵɵtext(10, "Show Recessions");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 4)(12, "a", 9);
        i0.ɵɵlistener("click", function IntradaysRatesComponent_Template_a_click_12_listener() { return ctx.goToFundChartTab(); });
        i0.ɵɵtext(13, "View Full Chart");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(14, "div", 10)(15, "div", 11)(16, "div", 12);
        i0.ɵɵelement(17, "ycn-simple-fund-chart", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 14)(19, "table", 15)(20, "thead")(21, "tr")(22, "td", 16);
        i0.ɵɵtext(23, "Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "td", 17);
        i0.ɵɵtext(25, "Level");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "td", 18);
        i0.ɵɵtext(27, "1 DAY CHG");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "td", 18);
        i0.ɵɵtext(29, "1 DAY % CHG");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(30, "tbody");
        i0.ɵɵrepeaterCreate(31, IntradaysRatesComponent_For_32_Template, 12, 7, "tr", null, _forTrack0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(33, "div", 19);
        i0.ɵɵtext(34);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵtwoWayProperty("ngModel", ctx.showRecessions);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("calcs", ctx.chartCalcs)("showRecessions", ctx.showRecessions)("securityIds", ctx.indicesList);
        i0.ɵɵadvance(14);
        i0.ɵɵrepeater(ctx.indices);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("As of ", ctx.latestDate, " EST");
    } }, dependencies: [i4.SimpleFundChartComponent, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel], encapsulation: 2 });
